import React from "react";
import mockUp from "../assets/images/Mockup.png";
import googleButton from "../assets/images/google-play-badge 2.png";

const Download = () => {
  return (
    <>
      <div className="px-8 lg:px-32 xl:px-52 ml-5">
        <div className="container mx-auto flex flex-col items-center text-center md:flex-row px-4 py-8 md:py-16">
          <div className="w-full  text-center md:text-left mt-20 sm:-mt-1 download-class">
            <p className="text-2xl md:text-3xl font-bold ">Download Now:</p>
            <div className="flex justify-center md:justify-start mt-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.sstech.quickchat"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googleButton}
                  alt="Google Play Button"
                  className="w-32 h-auto md:w-52 -ml-2 google-btn"
                />
              </a>
            </div>
          </div>

           <div className="flex flex-col items-center md:flex-row md:justify-center md:mt-0 sm:mt-3">
          <img src={mockUp} alt="Illustration" className="mockup-img" />
      </div>
        </div>
      </div>
    </>
  );
};

export default Download;
